import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
// Fichas de marca compartidas con el otro frontal; van ANTES para que
// app.css pueda redefinir lo que necesite.
import '@capi/shared/styles/brand.css';
import './styles/app.css';

// La medición de consumo arranca con la aplicación: si empezara al entrar a
// una pantalla concreta, el tráfico del arranque —que es el más pesado del
// día, porque descarga el cuestionario y la cartografía— no se contaría.
import { startDataUsage } from './telemetry/dataUsage';

startDataUsage();

const container = document.getElementById('root');
if (!container) throw new Error('No se encontró el elemento #root.');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
